export default __webpack_public_path__ + "media/brands/shutterstock-95fbf6d3.png";